export const MARKETPLACE_CART_SIGNUP_PATH = '/signup/marketplace-cart/s?checkout_item_type=marketplace_cart';

const USER_QA_HOSTS = new Set([
    'staging.productioncrate.com',
    'user-qa.productioncrate.com',
]);

const LOCAL_HOSTS = new Set([
    'localhost',
    '127.0.0.1',
]);

export const getMarketplaceCartSignupUrl = (windowObject = window) => {
    const hostname = windowObject.location?.hostname || '';

    if (LOCAL_HOSTS.has(hostname) || hostname.endsWith('.localhost')) {
        return MARKETPLACE_CART_SIGNUP_PATH;
    }

    const userHost = USER_QA_HOSTS.has(hostname)
        ? 'user-qa.productioncrate.com'
        : 'user.productioncrate.com';

    return `https://${userHost}${MARKETPLACE_CART_SIGNUP_PATH}`;
};

export const navigateToMarketplaceCartSignup = (windowObject = window) => {
    windowObject.location.href = getMarketplaceCartSignupUrl(windowObject);
};
